module.exports = __webpack_public_path__ + "img/close-gray.31c91f02.svg";